import React, { useState } from 'react';
import { View } from 'react-native';
import type { StylesMap } from 'types';

import styles from './styles';
import SelectButton from './SelectButton';
import LanguageSelectPopup from './LanguageSelectPopup';

/**
 * Types
 */
export interface LanguageSelectorProps {
    languages: string[];
    currentLanguage: string;
    onSelect: (language: string) => void;
    style: StylesMap;
}

const LanguageSelector = ({
    languages,
    currentLanguage,
    style,
    onSelect
}: LanguageSelectorProps): JSX.Element => {
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    return (
        <View style={[styles.container, style]} testID="language_button">
            <SelectButton
                onPress={() => setIsPopupVisible(!isPopupVisible)}
                label={currentLanguage}
            />
            <View style={styles.popupContainer}>
                {isPopupVisible && (
                    <LanguageSelectPopup
                        languages={languages}
                        currentLanguage={currentLanguage}
                        onSelect={(language) => {
                            setIsPopupVisible(false);
                            onSelect(language);
                        }}
                    />
                )}
            </View>
        </View>
    );
};

export default LanguageSelector;
